var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.14592H4.10066C4.22878 10.517 4.98455 12.8114 6.29063 14.7944C4.65466 14.5375 3.14995 13.7456 2.01179 12.5427C0.873618 11.3398 0.166151 9.7936 0 8.14592ZM0 6.64851C0.166151 5.00084 0.873618 3.45466 2.01179 2.25174C3.14995 1.04882 4.65466 0.256973 6.29063 0C4.98455 1.98303 4.22878 4.27747 4.10066 6.64851H0ZM14.8993 6.64851H10.7986C10.6705 4.27747 9.9147 1.98303 8.60862 0C10.2446 0.256973 11.7493 1.04882 12.8875 2.25174C14.0256 3.45466 14.7331 5.00084 14.8993 6.64851ZM14.8993 8.14592C14.7331 9.7936 14.0256 11.3398 12.8875 12.5427C11.7493 13.7456 10.2446 14.5375 8.60862 14.7944C9.9147 12.8114 10.6705 10.517 10.7986 8.14592H14.9H14.8993ZM5.60032 8.14592H9.29893C9.1757 10.167 8.53922 12.1234 7.44963 13.8301C6.36003 12.1234 5.72355 10.167 5.60032 8.14592ZM5.60032 6.64851C5.72355 4.62739 6.36003 2.67106 7.44963 0.964334C8.53922 2.67106 9.1757 4.62739 9.29893 6.64851H5.60032Z",
    fill: "#09121F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.98c1c66d.svg";
export { ForwardRef as ReactComponent };